import { routerApp, baseUrl, enableOnPremise } from '../../app.module';
import { httpRequestGenerator } from '../../services/utilities';

routerApp.factory('UserService', ['$http', function($http) {
    var requestFunc = httpRequestGenerator(enableOnPremise, $http);
    return {
        updateFleetPerformanceSettings: function(userId, newSettings) {

            return requestFunc({
                url: baseUrl + 'users/' + userId + '/fleetPerformanceSettings',
                method: 'POST',
                data: {
                    fleet_performance: {
                    date_range: newSettings.dateRange,
                    voyage_leg: newSettings.voyageLeg,
                    bf: newSettings.bf,
                    report_from: newSettings.reportFrom.toISOString(),
                    report_to: newSettings.reportTo.toISOString(),
                    selected_classes: newSettings.selectedClasses,
                    selected_vessels: newSettings.selectedVessels,
                    selected_metric: newSettings.selectedMetric,
                    selected_metric_reverse: newSettings.selectedMetricReverse
                }
            }});
        }
    };
}]);
